/** @mui/material imports */
/** @mui/icons-material imports */
/** React imports */
import React, { useEffect, useContext } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
/** App imports */
import Config from '../config';
import { appContext } from '../../Contexts/AppContext';
import { errorHandler } from '../error/error-handler';
import { getProject } from '../authenticated-requests/projects';
import { ProjectObject, ValidatorProps } from '../../TypeScript/interfaces';

/**
 * Validate the project id in the path and update context
 * @param props standard validator props
 * @returns child component with validation applie
 */
const ProjectValidator: React.FC<ValidatorProps> = (
  props: React.PropsWithChildren<ValidatorProps>,
): JSX.Element => {
  const navigate = useNavigate();
  const location = useLocation();
  const targetProjectId = useParams().projectId;
  const { setAppLoading, activeProject, setActiveProject, company } =
    useContext(appContext);

  useEffect(() => {
    validateProjectId(targetProjectId || '');
  }, [location]);

  const validateProjectId = (projectId: string): void => {
    if (projectId === activeProject.id) {
      // VALID PROJECT. NO NEED TO REVALIDATE
    } else if (projectId === Config.default_project) {
      const commonProject: ProjectObject = {
        id: 'common',
        company,
        type: 'common',
        createdBy: 'System',
        title: 'Common Project',
      };
      handleValidProjectId(commonProject);
    } else if (projectId !== '') {
      setAppLoading(true);
      getProject(company, projectId, true)
        .then((project: ProjectObject) => {
          setAppLoading(false);
          if (project && project.id === targetProjectId) {
            handleValidProjectId(project);
          } else {
            handleInvalidProjectId();
          }
        })
        .catch((err) => {
          setAppLoading(false);
          errorHandler(err);
          handleInvalidProjectId();
        });
    } else {
      handleNoProjectId();
    }
  };

  const handleInvalidProjectId = (): void => {
    setActiveProject({});
    navigate(`/${company}`);
  };

  const handleValidProjectId = (project: ProjectObject): void => {
    setActiveProject(project);
  };

  // To clear the project context on root paths
  const handleNoProjectId = (): void => {
    setActiveProject({});
  };

  return <>{props.children}</>;
};

export default ProjectValidator;
